import store from "@/state/store";

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "Login",
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      title: "Logout",
      beforeResolve(routeTo, routeFrom, next) {
        const preferenceUser = sessionStorage.getItem('userId') || sessionStorage.getItem('username') || 'anonymous';
        const preferenceKeys = [
          `workflow:${preferenceUser}:step-editor-view`,
          `workflow:${preferenceUser}:process-realm`,
        ];
        const savedPreferences = preferenceKeys
          .map(key => [key, localStorage.getItem(key)])
          .filter(([, value]) => value !== null);

        localStorage.clear();
        savedPreferences.forEach(([key, value]) => localStorage.setItem(key, value));
        sessionStorage.clear();
        next();
      },
    },
    component: () => import("../views/auth/logout/basic")
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/account/forgot-password.vue"),
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/",
    name: "default",
    meta: {
      title: "Dashboard",
      authRequired: true,
      privileges: []
    },
    component: () => import("../views/system/index.vue"),
  },
]
